export default {
  title: 'Cek Biaya Ongkir',
  origin: 'Area Pengirim',
  originPlaceholder: 'Masukan kota asal pengiriman',
  destination: 'Area Penerima',
  destinationPlaceholder: 'Masukan kota tujuan pengiriman',
  weight: 'Berat Barang',
  weightPlaceholder: 'Masukan berat barang',
  logistic: 'Logistik',
  allLogistic: 'Semua Logistik',
  submit: 'Cek Ongkir',
  invalidTitle: 'Informasi biaya belum tersedia',
  invalidDesc: 'Silahkan isi form cek ongkir untuk memunculkan biaya cek ongkir',
  dataNotFound: 'Maaf data tidak ditemukan!',
  show: 'Menampilkan',
  service: 'layanan pengiriman',
  typeService: 'Jenis layanan'
}